import type { VoidFunctionComponent } from 'react';
import List from '../../../../../generic/List';
import LicensingSection from './LicensingSection';
import type { Dependency } from '../../../../../../../shared/dependenciesV2';

type Props = {
  // Dependency data from API response
  dependency: Dependency;
};

/**
 * Displays issue and license details for a dependency
 */
const DetailsRow: VoidFunctionComponent<Props> = ({ dependency }) => {
  return (
    <List.RowDetails>
      <LicensingSection
        licenses={dependency.licenses}
        declaredLicenses={dependency.declaredLicenses}
        issues={dependency.issues}
      />
    </List.RowDetails>
  );
};

export default DetailsRow;
